angular
    .module('cabinetApp')
    .factory('paymentsModel', function($http) {
        var paymentsModel = {};

        // Загрузка транзакций
        paymentsModel.getTransactions = function(params, success, error) {
            return $http.get('/api/v2/billing/transactions/', { params: params })
                .then(function(response){
                    return response['data']['data'];
                })
                .then(success, error);
        };

        // Загрузка списка оплат
        paymentsModel.getPaymentList = function(params, success, error) {
            return $http.get('/api/v4/forms/tenant_accruals/', { params })
                .then(function(response){
                    return response['data']['data'];
                })
                .then(success, error);
        };

        return paymentsModel;
    });